// extracted by mini-css-extract-plugin
export var chevron = "_ja-2";
export var dropdownItems = "_ja-0";
export var item = "_ja-1";